// actions
export const SETUP_APP_VERSION_CHECK = 'SETUP_APP_VERSION_CHECK'
export const REFRESH_APP = 'REFRESH_APP'

// mutations
export const SET_INITIAL_APP_VERSION = 'SET_INITIAL_APP_VERSION'
export const SET_LATEST_APP_VERSION = 'SET_LATEST_APP_VERSION'
